import contactData from "~/data/contactData.json";

export const useContactData = () => {
  return contactData;
};

export type ContactData = typeof contactData;
export type TempleLocation = (typeof contactData.templeLocations)[0];
export type SocialPlatform = (typeof contactData.socialMedia.platforms)[0];
export type YoutubeChannel = (typeof contactData.socialMedia.youtubeChannels)[0];
export type MobileApp = (typeof contactData.socialMedia.mobileApps)[0];
export type TempleHour = (typeof contactData.templeHours)[0];
